<template>
    <div class="invalid-feedback d-block">
        <transition name="slide-down">
            <div v-if="bag.length || error">
                {{ error ? error : bag[0] }}
            </div>
        </transition>
    </div>
</template>

<script>
import { mapState } from "vuex";

export default {
    props: {
        errors: String,
        error: String,
    },

    computed: {
        ...mapState(["board"]),

        bag() {
            var bag = this.$getErrors(this.errors);
            return _.isArray(bag) ? bag : [bag];
        },
    },
};
</script>
